class SaleCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.timeElement = this.querySelector('time');

    if (!this.timeElement) {
      this.hidden = true;
      return;
    }

    this.#update();
    this.#timer = window.setInterval(() => this.#update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #update() {
    const now = new Date();
    const nextMidnight = new Date(now);
    nextMidnight.setHours(24, 0, 0, 0);
    const remainingSeconds = Math.max(0, Math.floor((nextMidnight.getTime() - now.getTime()) / 1000));
    const hours = Math.floor(remainingSeconds / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    const duration = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');

    this.timeElement.textContent = duration;
    this.setAttribute('aria-label', `${this.dataset.label} ${duration}`);
  }
}

if (!customElements.get('sale-countdown')) {
  customElements.define('sale-countdown', SaleCountdown);
}
